import { z } from 'zod';

export const notifyQuestionedSchema = z.object({
  notify_creditor_ids: z.array(z.string()),
});

type NotifyQuestionedSchemaType = z.infer<typeof notifyQuestionedSchema>;

const defaultValue: NotifyQuestionedSchemaType = {
  notify_creditor_ids: ['CODIGO_1', 'CODIGO_2'],
};

export const NotifyQuestionedDefaultValue = JSON.stringify(defaultValue, null, '\t');
